import { useState } from "react";

import styled from "styled-components/macro";

import { FamilyRelationshipPicker } from "UserProfile/Family/Relationships/FamilyRelationshipPicker";
import { AnimatePresence } from "framer-motion";

import {
  FnrPopoverOption,
  FnrPopoverOptionIcon,
  FnrPopoverOptionsList,
} from "UI/FnrPopover2";

export default function NewRespondentPopover({
  buttonRef,
  show,
  onClose,
  addNewRespondent,
  addNewHouseholdRespondent,
  userID,
  goStraightToRelationshipModal,
}) {
  const [showRelationshipModal, setShowRelationshipModal] = useState(
    (show && goStraightToRelationshipModal) || false
  );

  const openRelationshipModal = () => {
    setShowRelationshipModal(true);
    onClose();
  };

  const closeRelationshipModal = () => {
    setShowRelationshipModal(false);
  };

  const handleAddNewHouseholdRespondent = (newUser, newHouseholdID) => {
    addNewHouseholdRespondent(newUser, newHouseholdID);
    closeRelationshipModal();
    onClose();
  };

  const handleAddNewRespondent = () => {
    addNewRespondent();
    closeRelationshipModal();
    onClose();
  };

  if (goStraightToRelationshipModal)
    return (
      <AnimatePresence>
        {showRelationshipModal && (
          <FamilyRelationshipPicker
            profileUserID={userID}
            closeOverlay={closeRelationshipModal}
            onFinish={handleAddNewHouseholdRespondent}
          />
        )}
      </AnimatePresence>
    );

  return (
    <>
      <FnrPopoverOptionsList
        buttonRef={buttonRef}
        show={show}
        onShouldClose={onClose}
      >
        <Wrapper>
          <Title>Is this a family member in your household?</Title>
          <FnrPopoverOption onClick={openRelationshipModal}>
            <FnrPopoverOptionIcon icon="users-medical fas" />
            <Option>Yes, add them to my household as well</Option>
          </FnrPopoverOption>
          <FnrPopoverOption onClick={handleAddNewRespondent}>
            <FnrPopoverOptionIcon icon="user-plus fas" />
            {/* <Option>Sign someone else up</Option> */}
            <Option>No, I just want to sign them up</Option>
          </FnrPopoverOption>
        </Wrapper>
      </FnrPopoverOptionsList>
      <AnimatePresence>
        {showRelationshipModal && (
          <FamilyRelationshipPicker
            profileUserID={userID}
            closeOverlay={closeRelationshipModal}
            onFinish={handleAddNewHouseholdRespondent}
          />
        )}
      </AnimatePresence>
    </>
  );
}

const Wrapper = styled.div`
  padding: 6px;

  @media screen and (max-width: 400px) {
    max-width: 255px;
  }
`;

const Title = styled.div`
  margin-bottom: 6px;
`;

const Option = styled.div`
  margin-left: 4px;
`;
